import React, { memo } from 'react';
import classNames from 'classnames';

import { Card } from '../Card';

import style from './style.module.css';

const GridCardComponent = ({ className, title, actions, dense = false, children }) => (
  <Card actions={actions} className={classNames({ [style.roomy]: !dense }, className)} title={title} flush>
    <div className={style.body}>{children}</div>
  </Card>
);

/**
 * Flush card around an AG-Grid table, with an optional title row.
 *
 * @param props.dense Keeps the global dense 4px cells, for wide page-level data grids. Widget tables get 8px cells.
 */
export const GridCard = memo(GridCardComponent);
